import { ref } from 'vue';
import { defineStore } from 'pinia';

export interface ProjectItem {
    id: number;
    name: string;
    issue_count?: number;
    issueCount?: number;
    [key: string]: any;
}

const useProjectsStore = defineStore(
    'projects',
    () => {
        // 项目列表数据
        const projectsList = ref<ProjectItem[]>([]);
        // 是否已加载过项目列表
        const isLoaded = ref<boolean>(false);
        // 加载状态
        const loading = ref<boolean>(false);

        // 设置项目列表
        const setProjects = (projects: ProjectItem[]) => {
            projectsList.value = projects;
            isLoaded.value = true;
        };

        // 清空项目列表
        const clearProjects = () => {
            projectsList.value = [];
            isLoaded.value = false;
        };

        // 设置加载状态
        const setLoading = (status: boolean) => {
            loading.value = status;
        };

        // 获取项目选项（用于下拉列表）
        const getProjectOptions = () => {
            return projectsList.value.map(project => ({
                label: project.name || project.project_name || '',
                value: project.id || project.project_id,
            }));
        };

        return {
            projectsList,
            isLoaded,
            loading,
            setProjects,
            clearProjects,
            setLoading,
            getProjectOptions,
        };
    },
    {
        // 可选：开启持久化
        // persist: {
        //     storage: localStorage,
        //     key: 'projects-store',
        //     paths: ['projectsList', 'isLoaded'],
        // },
    }
);

export default useProjectsStore;

